import { useAuth } from '~/hooks/auth';

import { Container } from './styles';

const AccountDropdown = () => {
  const { signOut } = useAuth();

  return (
    <Container onClick={signOut}>
      <span>Sair</span>
    </Container>
  );
};

export default AccountDropdown;
